
import { GenericEntityMetadata, PropertyMetadata, nullIfContainsNull } from '@scisys-uim/uim-common';


export class MaintenanceAspectMetadataBase extends GenericEntityMetadata {
  constructor() {
    super('MaintenanceAspect', {
      aspectAssetId: <PropertyMetadata> {
        name: 'aspectAssetId',
        type: 'number',
        plural: false,
        isIdentity: true,
        derived: false,
        required: true,
        readOnly: true,
        readable: true,
        writeable: false,
        unique: false
      },
      lockVersion: <PropertyMetadata> {
        name: 'lockVersion',
        type: 'number',
        plural: false,
        isIdentity: false,
        derived: true,
        required: false,
        readOnly: false,
        readable: true,
        writeable: true,
        unique: false
      },
      maintenanceType: <PropertyMetadata> {
        name: 'maintenanceType',
        type: 'string',
        plural: false,
        isIdentity: false,
        derived: false,
        required: true,
        readOnly: false,
        readable: true,
        writeable: true,
        length: 255,
        unique: false
      },
      periodicMaintenance: <PropertyMetadata> {
        name: 'periodicMaintenance',
        type: 'boolean',
        plural: false,
        isIdentity: false,
        derived: false,
        required: true,
        readOnly: false,
        readable: true,
        writeable: true,
        length: 1,
        unique: false
      },
      periodicMaintenanceDays: <PropertyMetadata> {
        name: 'periodicMaintenanceDays',
        type: 'number',
        plural: false,
        isIdentity: false,
        derived: false,
        required: false,
        readOnly: false,
        readable: true,
        writeable: true,
        unique: false
      },
      routineMaintenance: <PropertyMetadata> {
        name: 'routineMaintenance',
        type: 'boolean',
        plural: false,
        isIdentity: false,
        derived: false,
        required: true,
        readOnly: false,
        readable: true,
        writeable: true,
        length: 1,
        unique: false
      },
      routineMaintenanceDays: <PropertyMetadata> {
        name: 'routineMaintenanceDays',
        type: 'number',
        plural: false,
        isIdentity: false,
        derived: false,
        required: false,
        readOnly: false,
        readable: true,
        writeable: true,
        unique: false
      },
      visualInspection: <PropertyMetadata> {
        name: 'visualInspection',
        type: 'boolean',
        plural: false,
        isIdentity: false,
        derived: false,
        required: true,
        readOnly: false,
        readable: true,
        writeable: true,
        length: 1,
        unique: false
      }
    });
  }
  toKeyObject(item: any): any {
    const result = item?.aspectAssetId;
    return nullIfContainsNull(result);
  }
}



